/**
 * This service acts as a bridge to break circular dependency
 * between Axios interceptor and AuthContext.
 */
const AuthService = {
  logout: () => {
    // This function will be dynamically replaced by the actual function of the AuthContext
    console.error("La función de logout no ha sido registrada todavía.");
  },

  /**
   * The AuthContext will call this function to register its own logout function.
   * @param {Function} logoutFunction The real context logout function.
   */
  register: (logoutFunction) => {
    AuthService.logout = logoutFunction;
  },
};

export default AuthService;
